import React from "react";
import useHover from "../hooks/useHover";
import Checkbox from "../misc/elements/Checkbox";

const IncludeCategories = ({ includeCategories, setIncludeCategories }) => {
  const hover = useHover(<IncludeCatDescription />);
  return (
    <div
      onClick={() => setIncludeCategories(!includeCategories)}
      {...hover.divProps}
      className="divRow"
      style={{
        position: "absolute",
        left: 0,
        backgroundColor: "#2f2f2f",
        height: "100%",
        paddingRight: "5px",
        paddingLeft: "5px",
        cursor: "pointer",
      }}
    >
      <Checkbox item={includeCategories} otherItem={true} />
      <img className="icon25" src="/icons/icon_category.png" />
      {hover.hoverDescription}
    </div>
  );
};

const IncludeCatDescription = () => {
  return (
    <div style={{ backgroundColor: "#2f2f2f" }}>
      <div className="textBoldWhite">Include Categories in search</div>
    </div>
  );
};

export default IncludeCategories;
